export const normalizeResults = (questions, results, langISOCode) => {
  return questions.map((question) => {
    const language = question.languages[langISOCode] || question.languages[Object.keys(question.languages)[0]];
    const choices =
      question.options &&
      question.options.map((option) => {
        const { languages } = option;
        const optionLanguage = { message: languages[langISOCode] || languages[Object.keys(languages)[0]] };
        return {
          ...option,
          language: optionLanguage,
        };
      });
    const commonProps = {
      questionId: question.id,
      isAttributeBased: false,
      shouldShowLabels: question.hasLabels,
      questionType: question.type,
      choices,
      title: language.title,
      leftLabel: language.labelLow,
      rightLabel: language.labelHigh,
    };

    const matchedResult = results.find((result) => result.surveyElementId === question.id);
    if (!matchedResult) {
      return commonProps;
    }
    return {
      ...commonProps,
      canViewComments: true,
      result: matchedResult,
    };
  });
};
